"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Card-LearningPath.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_attrs0 = {
        "class": "col-sm-6",
        "data-ui-mode": "ns:col-sm-6|hs:col-xl-6 col-lg-12"
      },
    marko_attrs1 = {
        "class": "card item"
      },
    marko_attrs2 = {
        "class": "card-content"
      },
    marko_attrs3 = {
        "class": "row no-gutters"
      },
    marko_attrs4 = {
        "class": "col-lg-3 col-sm-4"
      },
    marko_attrs5 = {
        "class": "col-lg-9 col-sm-8"
      },
    marko_attrs6 = {
        "class": "card-body"
      },
    marko_attrs7 = {
        "class": "card-text text-ellipsis-2"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("b59bb7"),
    marko_node0 = marko_createElement("small", {
        "class": "text-muted mt-2 text-ellipsis"
      }, "9", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("i", {
          "class": "bx bx-time-five mr-1"
        }, null, null, 0)
      .t(" Today, 12:30am");

function render(input, out, __component, component, state) {
  var data = input;

  out.e("div", marko_attrs0, "0", component, 1)
    .e("div", marko_attrs1, "1", component, 1)
      .e("div", marko_attrs2, "2", component, 1)
        .e("div", marko_attrs3, "3", component, 2)
          .e("div", marko_attrs4, "4", component, 1)
            .e("img", {
                src: input.poster,
                alt: "element 01",
                "class": "h-100 w-100 rounded-left"
              }, "5", component, 0)
          .e("div", marko_attrs5, "6", component, 1)
            .e("div", marko_attrs6, "7", component, 2)
              .e("div", marko_attrs7, "8", component, 1)
                .t(input.description, component)
              .n(marko_node0, component);
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
